import { React, useState } from 'react';
import { Formik } from 'formik';
import { Button } from 'legacy_components/Button';
import { Input } from 'legacy_components/Input';
import { Select } from 'legacy_components/Select';
import styles from 'legacy_css_modules/ClientCompanyExport.module.css';

import { DatePicker } from 'legacy_components/DatePicker';
import 'react-datepicker/dist/react-datepicker.css';

import { FieldsWrapper } from 'legacy_components/FieldsWrapper';


const isValidEmail = (email) => {
    if (!email) return false;
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
};

export const ClientCompanyExport = ({ user, clientCompanies, ...props }) => {
    const [selectedCompanyId, setSelectedCompanyId] = useState("");
    const [buttonTitle, setButtonTitle] = useState("Odeslat zálohu na e-mail");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [busy, setBusy] = useState(false);
    
    const companiesWithIds = clientCompanies.map(company => ({
        id: company.id,
        title: company.title
    }));
  
    if (!selectedCompanyId && companiesWithIds.length > 0) {
        setSelectedCompanyId(companiesWithIds[0].id);
    }

    const handleCompanySelection = (e) => {
        setSelectedCompanyId(e);
    };

    const doFetchTriggerEmail = async () => {
        setButtonTitle("Požadavek se zpracovává...");
        setBusy(true);

        try {
            const url = `${process.env.REACT_APP_API}/trigger_client_company_export_email/?client_company=${selectedCompanyId}&dateFrom=${formatDate(dateFrom)}&dateTo=${formatDate(dateTo)}`;
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'JWT ' + localStorage.getItem('DocspointJWT'),
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (response.ok) {
                alert(data.message || "Export byl úspěšně spuštěn. Odkaz ke stažení obdržíte e-mailem.");
                setButtonTitle("Odeslat zálohu na e-mail");
                setBusy(false);
            } else {
                alert(data.error || "Při požadavku na export došlo k chybě.");
                setButtonTitle("Zkusit znovu");
                setBusy(false);
            }
        } catch (error) {
            alert("Nelze se spojit se serverem.");
            setButtonTitle("Zkusit znovu");
            setBusy(false);
        }
    };

    function formatDate(date) {
        if (!date) return "";
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    
    if (dateFrom === "") { setDateFrom(oneYearAgo); }
    if (dateTo === "") { setDateTo(today); }

    const handleChangeDateFrom = event => {
        setDateFrom(event);
    };

    const handleChangeDateTo = event => {
        setDateTo(event);
    };

    
    const isEmailInvalid = !user?.email || !isValidEmail(user.email);

    return (
        <>
            <br /><br />
            <h2>Export dokladů</h2>
            <div className={styles.formContainer}> 
                <div className={styles.field}>
                    <Formik initialValues={{ }}>
                        {({ values }) => (
                            <FieldsWrapper columns={3}>
                                <Input
                                    name="companies"
                                    component={Select}
                                    data={companiesWithIds}
                                    notNull={true}
                                    onChange={handleCompanySelection}
                                >
                                    Klientská společnost
                                </Input>
                                <Input
                                    name="exfrom"
                                    component={DatePicker}
                                    selected={dateFrom}
                                    customOnChange={handleChangeDateFrom}
                                >
                                    Od data
                                </Input>
                                
                                <Input
                                    name="exto"
                                    component={DatePicker}
                                    selected={dateTo}
                                    customOnChange={handleChangeDateTo}
                                >
                                    Do data
                                </Input>
                            </FieldsWrapper>
                        )}
                    </Formik>
                </div>
                <div className={styles.button}></div>
            </div>
            
            <div style={{ textAlign: 'right' }}>
                <Button 
                    onClick={doFetchTriggerEmail} 
                    disabled={busy || isEmailInvalid}
                >
                    {isEmailInvalid ? "Vyplňte email" : buttonTitle}
                </Button>
            </div>
        </>    
    );
};